@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.favoritepoints
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.web.dto.pointsOfIntrest.PointOfInterestDto

class FavoritePointDto(
    val id: KmmLong?,
    val passengerId: KmmLong,
    val lat: Double,
    val lng: Double,
    val fullAddress: String,
    val name: String,
    val addressDetails: AddressDetailsDto?,
    val isDeleted: Boolean = false,
)

fun FavoritePointDto.getFullAddress() = fullAddress